import React, { useState } from "react";
import edit from "../../images/editprofile-icon.svg";
import ImageCrop from "../Popup/ImageCrop";
import Upload from "../Common/upload-image/Upload";
import { VIEW_ROLE } from "../../query/ViewRole";
import { hasuraClient } from "../../apolloClient";
import { useQuery } from "@apollo/react-hooks";

const EditProfileHeader = ({ data, BusinessProfile, refetch }) => {
  const [showModal, setShowModal] = useState(false);
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  return userRole?.users[0].role === "business" ? (
    <div className="edit-council-header">
      <div className="user-row">
        <div className="user-photo">
          {data?.users[0]?.business_profile?.business_profile_photo && (
            <img
              src={data?.users[0]?.business_profile?.business_profile_photo}
              alt="user"
            />
          )}
        </div>
        {data?.users[0].business_profile.business_profile_photo ? (
          <div onClick={() => setShowModal(true)} className="edit-photo">
            <button>
              <img src={edit} alt="edit profile icon" />
            </button>
          </div>
        ) : (
          <Upload
            iconVisible={true}
            data={data}
            refetch={refetch}
            BusinessProfile={BusinessProfile}
            ImageType="header"
          />
        )}
      </div>
      <ImageCrop
        popupTitle="Profile Image"
        show={showModal}
        onHide={() => setShowModal(false)}
        currentPhoto={data?.users[0].business_profile.business_profile_photo}
        BusinessProfile={BusinessProfile}
        data={data}
        refetch={refetch}
        ImageType="header"
      />
    </div>
  ) : (
    <div className="edit-council-header">
      <div className="user-row">
        <div className="user-photo">
          {data?.users[0]?.club_profile?.profile_photo && (
            <img src={data?.users[0]?.club_profile?.profile_photo} alt="user" />
          )}
        </div>
        {data?.users[0].club_profile.profile_photo ? (
          <div onClick={() => setShowModal(true)} className="edit-photo">
            <button>
              <img src={edit} alt="edit profile icon" />
            </button>
          </div>
        ) : (
          <Upload
            iconVisible={true}
            data={data}
            refetch={refetch}
            BusinessProfile={BusinessProfile}
            ImageType="header"
          />
        )}
      </div>
      <ImageCrop
        popupTitle="Profile Image"
        show={showModal}
        onHide={() => setShowModal(false)}
        currentPhoto={data?.users[0].club_profile.profile_photo}
        BusinessProfile={BusinessProfile}
        data={data}
        refetch={refetch}
        ImageType="header"
      />
    </div>
  );
};

export default EditProfileHeader;
